import { createContext, useContext, useRef, useState } from "react"
import { useEffect } from "react"
import { useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { toast, ToastContainer } from "react-toastify"
import 'react-responsive-modal/styles.css';
import ProcessModal from "@/components/ProcessModal";

export const GlobalContext = createContext(null)

const NavigationProvider = ({ children }) => {
  const [isToggled, setIsToggled] = useState(false)
  const [openGapura, setOpenGapura] = useState(false)
  const [isShowBG, setIsShowBG] = useState(false)
  const [initial, setInitial] = useState(0)
  const [categories, setCategories] = useState([])
  const [showEnterFont, setShowEnterFont] = useState(false)
  const [disabledDropdown, setDisabledDropdown] = useState(false)
  const [loading, setLoading] = useState("initial")
  const [isPlaying, setIsPlaying] = useState(true)
  const [processSaveModal, setProcessSaveModal] = useState(false);
  const [isLogOut, setIsLogOut] = useState(false)
  const [finishToggled, setFinishToggled] = useState(true)
  const [updateUserInCart, setUpdateUserInCart] = useState(false)
  const [seoContent, setSeoContent] = useState(null)
  const [modalContent, setModalContent] = useState(null)
  // const [provinces, setProvinces] = useState([])
  const [userDetail, setUserDetail] = useState({})
  // const [cities, setCities] = useState([])
  const [regions, setRegions] = useState([])
  const [productDetail, setProductDetail] = useState({})
  const [products, setProducts] = useState([])
  const [productRecomms, setProductRecomms] = useState([]) // TODO: berhubung yg pakai hanya di page products, ditaruh di sana saja, jika candra mau buatin api buat get recomm
  const [onReqDiSana, setOnReqDiSana] = useState(true)
  const [productsPerPage, setProductsPerPage] = useState([])
  const openingHeader = useRef(null)
  let location = useLocation()
  let pathname = location.pathname
  let locSearch = location.search
  const authStore = useSelector(({ auth }) => auth)
  const orderStore = useSelector(({ order }) => order)
  const userConfig = ""

  const notifyError = (errText) => {
    toast.error(errText, {
      className: "text-[#6e605d] font-light font-agcasmlt text-sm sm:text-xl"
    })
  }

  const notifySuccess = (notifyText) => {
    toast.success(notifyText, {
      className: "text-[#6e605d] font-light font-agcasmlt text-sm sm:text-xl"
    })
  }

  const notifyInfo = (notifyText) => {
    toast.info(notifyText, {
      className: "text-[#6e605d] font-light font-agcasmlt text-sm sm:text-xl"
    })
  }

  /*
  // show temporary closure modal once when the NavigationProvider mounts (i.e. on full page load)
  useEffect(() => {
    const content = {
      title: "Temporary Closure Notice",
      msg: "We will be closed at 3:00 PM on Saturday, September 5, 2026.\nWe will reopen on Sunday, September 6, 2026 at 10:00 AM.",
      isOpen: true
    }
    // Do not auto-show the global modal when the user lands on the homepage
    if (pathname !== "/") {
      setModalContent(content)
    }
  }, [])
  */

  return (
    <>
      <GlobalContext.Provider value={{
        pathname,
        locSearch,
        isToggled,
        setIsToggled,
        openGapura,
        setOpenGapura,
        isShowBG,
        setIsShowBG,
        initial,
        setInitial,
        showEnterFont,
        setShowEnterFont,
        openingHeader,
        disabledDropdown,
        setDisabledDropdown,
        loading,
        setLoading,
        isPlaying,
        setIsPlaying,
        authStore,
        orderStore,
        userConfig,
        notifyError,
        notifySuccess,
        notifyInfo,
        processSaveModal,
        setProcessSaveModal,
        isLogOut,
        setIsLogOut,
        categories,
        setCategories,
        finishToggled,
        setFinishToggled,
        userDetail,
        setUserDetail,
        regions,
        setRegions,
        updateUserInCart,
        setUpdateUserInCart,
        productDetail,
        setProductDetail,
        products,
        setProducts,
        productRecomms,
        setProductRecomms,
        productsPerPage,
        setProductsPerPage,
        onReqDiSana,
        setOnReqDiSana,
        seoContent,
        setSeoContent
      }}>
        <ToastContainer />
        {/* Global temporary closure modal shown once on initial app mount
        <ProcessModal pModalContent={modalContent} />
        */}
        {children}
      </GlobalContext.Provider>
    </>
  )
}

export default NavigationProvider
export const useGlobalContext = () => useContext(GlobalContext)